import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link, } from "react-router-dom";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Articles.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { FaShoppingCart } from "react-icons/fa";

export default function DailyNews() {
    const [activePdfUrl, setActivePdfUrl] = useState(null);

  const baseUrl = "https://porvaall.com/PMadmin/admin_api/";
    const navigate = useNavigate();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const articlesPerPage = 30;
    const [categories, setCategories] = useState([]);
    const [categoriesLoading, setCategoriesLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [toastMessage, setToastMessage] = useState("");
    const [books, setBooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchParams] = useSearchParams();
    const mp_id = searchParams.get("mp_id");
    const sp_id = searchParams.get("sp_id");

    const [pageLoading, setPageLoading] = useState(true);


    /* Toast auto-hide */
    useEffect(() => {
        if (toastMessage) {
            const t = setTimeout(() => setToastMessage(""), 1800);
            return () => clearTimeout(t);
        }
    }, [toastMessage]);

    /* Fetch books from API */
    /* */
    useEffect(() => {
        const fetchBooks = async () => {
            setLoading(true);
            setBooks([]);
            setCurrentPage(1);

            try {
                let res;
                res = await fetch(`${API_BASE_URL}daily_news_list.php`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({}),
                });


                const data = await res.json();

                if (data?.head?.code === 200) {
                    setBooks(
                        data.body.map((book) => ({
                            cat_id: book.cat_id,
                            news_id: book.news_id,
                            title: book.title,
                            cover_image: book.cover_image,
                            publishdate: book.publishdate,
                            pdf_file: book.pdf_file,
                        })),
                    );
                } else {
                    setBooks([]);
                }
            } catch (err) {
                console.error("Error fetching books:", err);
                setBooks([]);
            } finally {
                setLoading(false);
            }
        };

        fetchBooks();
    }, [API_BASE_URL, mp_id, sp_id]);
    const openPdfInNewTab = (news_id) => {
        navigate(`/daily-news-pdf/${news_id}`, {
            state: { news_id: news_id },
        });
    };
    // 2. FETCH POPULAR CATEGORIES
    /*  */
    useEffect(() => {
        const fetchCategories = async () => {
            setPageLoading(true); // start loader
            try {
                const response = await fetch(`${API_BASE_URL}subcategory_list.php`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({}),
                });

                const data = await response.json();
                console.log("API Response:", data);

                if (data.head.code === 200 && data.body.length > 0) {
                    // Sort the raw API data by subcategory_rank first
                    const sortedRaw = data.body.sort((a, b) => {
                        const rankA = Number(a.subcategory_rank) || 0; // ensure number
                        const rankB = Number(b.subcategory_rank) || 0;
                        return rankA - rankB; // ascending order
                    });

                    // Map to simplified objects after sorting
                    const sortedCategories = sortedRaw.map((item) => ({
                        name: item.subcategory_name,
                        img: item.subcategory_image,
                        mp_id: item.mp_id,
                        sp_id: item.sp_id,
                    }));

                    console.log("Sorted Categories:", sortedCategories);

                    setCategories(sortedCategories);
                } else {
                    console.warn("No categories found:", data.head.msg);
                    setCategories([]);
                }
            } catch (err) {
                console.error("Error fetching categories:", err);
                setCategories([]);
            } finally {
                setCategoriesLoading(false);
                setPageLoading(false); // start loader
            }
        };

        fetchCategories();
    }, [API_BASE_URL]);

    //  const openPdfInNewTab = ({ news_id }) => {
    //     navigate(`/daily-news-pdf/${news_id}`, {
    //       state: { news_id: news_id },
    //     });
    //   };

    const handleCategoryClick = ({ mp_id, sp_id }) => {
        navigate(`/articles?mp_id=${mp_id}&sp_id=${sp_id}`);
    };

    /* Add to cart with Stock Validation */
    const addToCart = (book) => {
        let cart = JSON.parse(localStorage.getItem("cart")) || [];
        const cartId = `book-${book.p_id}-${book.mp_id}-${book.sp_id}`;
        const existingIndex = cart.findIndex((item) => item.id === cartId);

        if (existingIndex !== -1) {
            // Check if current quantity in cart exceeds available stock
            if (cart[existingIndex].quantity >= book.stock) {
                setToastMessage(`Only ${book.stock} items available in stock!`);
                return;
            }
            cart[existingIndex].quantity += 1;
            setToastMessage(`Quantity Updated`);
        } else {
            cart.push({
                id: cartId,
                code: book.product_code,
                mpid: book.mp_id,
                spid: book.sp_id,
                product_id: book.p_id,
                title: book.product_name,
                image: book.cover_image,
                price: book.online_rate,
                mrp: book.mrp_rate,
                quantity: 1,
                itemType: "book",
                tax: book.product_tax,
                type: "Hardcopy",
                plan: "Single",
                availableStock: book.stock, // ✅ Pass stock value to cart for further validations
            });
            setToastMessage("Book added to cart!");
        }

        localStorage.setItem("cart", JSON.stringify(cart));
        window.dispatchEvent(new Event("cartUpdated"));
    };

    const PageLoader = () => (
        <div
            style={{
                minHeight: "70vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
            }}
        >
            <div
                className="spinner-border"
                role="status"
                style={{ width: "3rem", height: "3rem", color: "#f64a1aff" }}
            />
            <p className="mt-3 fw-semibold">Loading Books...</p>
        </div>
    );

    /* Pagination Logic */
    const totalPages = Math.ceil(books.length / articlesPerPage);
    const indexOfLast = currentPage * articlesPerPage;
    const indexOfFirst = indexOfLast - articlesPerPage;
    const currentBooks = books.slice(indexOfFirst, indexOfLast);

    if (loading) return <PageLoader />;

    return (
        <div className="container-fluid books-container">
            {/* HERO SECTION */}
            <motion.section
                className="text-center d-flex align-items-center justify-content-center mb-4"
                style={{
                    minHeight: "20vh",
                    background: "#0b2747",
                    color: "white",
                    padding: "30px 20px",
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
            >
                <div className="container">
                    <motion.h1 className="display-4 fw-bold">Porvaall Daily News</motion.h1>
                    <motion.p className="lead mt-3">
                        Inspiring knowledge. Empowering minds.
                    </motion.p>
                </div>
            </motion.section>

            <div className="container">
                <div className="row g-2">
                    {currentBooks.map((book, i) => {
                        const isOutOfStock = book.stock <= 0;

                        return (
                            <motion.div
                                key={book.p_id}
                                className="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3"
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: i * 0.02 }}
                            >
                                <motion.div
                                    whileHover={!isOutOfStock ? { scale: 1.03 } : {}}
                                    className="text-center"
                                >
                                    <div
                                        className={`card shadow-sm border-0 book-card ${isOutOfStock ? "out-of-stock-card" : ""}`}
                                        onClick={() =>
                                            navigate("/news_preview", {
                                                state: {
                                                    mag: { news_id: book.news_id, title: book.title },
                                                },
                                            })
                                        }
                                    >
                                        {/* {isOutOfStock && (
                        <div className="out-of-stock-badge">Sold Out</div>
                    )} */}
                                        <img
                                            loading="lazy"
                                            src={book.cover_image}
                                            alt={book.product_name}
                                            className="book-img"
                                            style={{
                                                filter: isOutOfStock ? "grayscale(100%)" : "none",
                                                opacity: isOutOfStock ? 0.6 : 1,
                                            }}
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                navigate(
                                                    `/dailyNews`,
                                                );
                                            }}
                                        />
                                    </div>

                                    <p className="mt-2 mb-1 fw-semibold book-title">
                                        {book.title.length > 15
                                            ? `${book.title.slice(0, 15)}`
                                            : book.title}

                                        {book.title.length > 15 && (
                                            <span
                                                className="ms-1 text-dark"
                                                style={{ cursor: "pointer", fontSize: "0.85rem" }}
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    navigate(
                                                        `/bookdescription/${book.p_id}?mp_id=${book.mp_id}&sp_id=${book.sp_id}`,
                                                    );
                                                }}
                                            >
                                                ...
                                            </span>
                                        )}
                                    </p>

                                    <p className="mb-2 book-price">
                                        <span className="fw-bold text-success me-2">
                                            {new Date(book.publishdate).toLocaleDateString("en-GB")}
                                        </span>
                                        {/* {Number(book.mrp_rate) > 0 && (
                      <span className="text-danger text-decoration-line-through">
                        ₹{book.mrp_rate}
                      </span>
                    )} */}
                                    </p>

                                    {/* <button
                                        className={`add-to-cart-btn w-100 position-relative ${isOutOfStock ? "disabled-btn" : ""}`}
                                        // onClick={() => !isOutOfStock && addToCart(book)}
                                        onClick={() =>
                                            navigate("/news_preview", {
                                                state: {
                                                    mag: { news_id: book.news_id, title: book.title },
                                                },
                                            })
                                        }
                                        disabled={isOutOfStock}
                                        style={{
                                            backgroundColor: isOutOfStock ? "#6c757d" : "",
                                            border: isOutOfStock ? "none" : "",
                                            cursor: isOutOfStock ? "not-allowed" : "pointer",
                                        }}
                                    >
                                        <span className="cart-btn-text">
                                            {isOutOfStock ? "Out of Stock" : "Preview"}
                                        </span>
                                        {!isOutOfStock && (
                                            <span className="cart-icon-wrapper">
                                                <FaShoppingCart size={16} />
                                            </span>
                                        )}
                                    </button> */}
                                    {/* <div className="d-flex gap-2"> */}
                                    {/* Preview Button */}
                                    {/* <button
        className={`add-to-cart-btn position-relative flex-fill ${isOutOfStock ? "disabled-btn" : ""}`}
        onClick={() =>
            navigate("/news_preview", {
                state: {
                    mag: { news_id: book.news_id, title: book.title },
                },
            })
        }
        disabled={isOutOfStock}
        style={{
            backgroundColor: isOutOfStock ? "#6c757d" : "",
            border: isOutOfStock ? "none" : "",
            cursor: isOutOfStock ? "not-allowed" : "pointer",
        }}
    >
        <span className="cart-btn-text">
            {isOutOfStock ? "Out of Stock" : "Preview"}
        </span>
    </button> */}

                                    {/* Add to Cart Button */}
                                    {/* <button
        className="add-to-cart-btn position-relative flex-fill"
                        //    onClick={openPdfInNewTab(book.news_id)}
                        onClick={() => openPdfInNewTab(book.news_id)}

    >
        <span className="cart-btn-text">Add to Cart</span>
        <span className="cart-icon-wrapper">
            <FaShoppingCart size={16} />
        </span>
    </button>
</div> */}
                                    <button
                                        className="btn btn-outline-primary form-control mt-3 addbtn"
                                        // old method (not work, having issue)
                                        // onClick={() => openPdfInNewTab(book.news_id)}
                                        //open pdf in new tab
                                        onClick={() => {
                                            const baseUrl = "https://porvaall.com/PMadmin/admin_api/";
                                            const fullPdfUrl = `${baseUrl}${book.pdf_file}`;
                                            window.open(fullPdfUrl, "_blank", "noopener,noreferrer");
                                        }}
                                        //open pdf in current tab
                                        // onClick={() => setActivePdfUrl(`${baseUrl}${book.pdf_file}`)}
                                    >
                                        Read PDF
                                    </button>
                                </motion.div>
                            </motion.div>
                        );
                    })}
                </div>

                  {/* 2. Embedded PDF Viewer Panel (Shows only when a PDF is selected) */}
      {activePdfUrl && (
        <div className="pdf-viewer-container mt-5 p-3 border rounded bg-light">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>Viewing Document</h4>
            {/* Button to close the PDF viewer */}
            <button 
              className="btn btn-danger btn-sm" 
              onClick={() => setActivePdfUrl(null)}
            >
              Close PDF
            </button>
          </div>
          
          {/* The magic iframe that displays the PDF natively */}
          <iframe
            src={activePdfUrl}
            title="PDF Viewer"
            width="100%"
            height="600px"
            style={{ border: 'none' }}
          />
        </div>
      )}

                {/* Toast Notification */}
                {toastMessage && (
                    <motion.div
                        initial={{ opacity: 0, scale: 0.7, y: -20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        className="toast-center"
                        style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translateX(-50%)",
                            backgroundColor: "#1d8535",
                            color: "#ffffff",
                            padding: "1rem 1.5rem",
                            borderRadius: "10px",
                            zIndex: 9999,
                            fontWeight: "bold",
                            fontSize: "1rem",
                            animation: "fadeInOut 3s forwards",
                            textAlign: "center",
                        }}
                    >
                        {toastMessage}
                    </motion.div>
                )}
                <hr />
                {/* POPULAR CATEGORIES */}
                <section className="py-3 bg-light">
                    <div className="container-fluid">
                        <div className="d-flex justify-content-between mb-3">
                            <h4>Magazine Categories</h4>
                            <Link
                                className="viewalllinks"
                                to="/magazines"
                                onClick={() => window.scrollTo(0, 0)}
                            >
                                View All
                            </Link>
                        </div>

                        <Swiper
                            modules={[Navigation, Autoplay]}
                            navigation
                            // loop
                            autoplay={{ delay: 2500 }}
                            spaceBetween={15}
                            slidesPerView={2}
                            breakpoints={{
                                425: { slidesPerView: 3 },
                                576: { slidesPerView: 4 },
                                768: { slidesPerView: 5 },
                                992: { slidesPerView: 6 },
                                1200: { slidesPerView: 8 },
                            }}
                        >
                            {categoriesLoading ? (
                                <p>Loading categories...</p>
                            ) : (
                                categories.map((cat, idx) => (
                                    <SwiperSlide key={idx}>
                                        <div
                                            className="category-box"
                                            style={{ backgroundImage: `url(${cat.img})` }}
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleCategoryClick({
                                                    mp_id: cat.mp_id,
                                                    sp_id: cat.sp_id,
                                                });
                                            }}
                                        >
                                            <div className="overlay">
                                                <h6>{cat.name}</h6>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))
                            )}
                        </Swiper>
                    </div>
                </section>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="d-flex justify-content-center mt-4">
                        <nav>
                            <ul className="pagination">
                                <li
                                    className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => {
                                            setCurrentPage((prev) => prev - 1);
                                            window.scrollTo({ top: 0, behavior: "smooth" });
                                        }}
                                    >
                                        Prev
                                    </button>
                                </li>
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                                    (num) => (
                                        <li
                                            key={num}
                                            className={`page-item ${currentPage === num ? "active" : ""}`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => {
                                                    setCurrentPage(num);
                                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                                }}
                                            >
                                                {num}
                                            </button>
                                        </li>
                                    ),
                                )}
                                <li
                                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => {
                                            setCurrentPage((prev) => prev + 1);
                                            window.scrollTo({ top: 0, behavior: "smooth" });
                                        }}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                )}
            </div>

          
        </div>
    );
}
